<template>
    <div class="quiz-body quiz-body--end">
      <div class="col-left">
        <h1>{{quiz.name}} completed!</h1>
        <p>Congratulations!
          You answered {{answered}} questions correctly<template v-if="earned">, earned {{earned}} points </template>.
        </p>
        <template v-if="badges">
          <p>You earned the next badges!</p>
          <div class="quiz-badge"><span class="box-played">{{played}}</span> Played 1 quiz</div>
          <div class="quiz-badge"><span class="box-reached">{{reached}}</span> Reaching 1,000 points</div>
        </template>
        <div class="buttons">
          <router-link class="button" :to="`/${$route.params.companySlug}/quizzes/leaderboard/${quiz.idQuiz}`">Go to leaderboard</router-link>
          <router-link class="button" :to="`/${$route.params.companySlug}/quizzes`">Finish</router-link>
        </div>
      </div>
      <img src="/web/quiz_completed.svg">
    </div>
</template>

<script>

export default {
  name: "QuizEnd",
  data () {
    return {
      badges: false,
      earned: 0,
      played: 1,
      reached: '1k',
    }
  },
  computed: {
    quiz() {
      return this.$store.getters.quiz
    },
    answered() {
      let count = 0;
      this.quiz._embedded.Questions.forEach(question => {
        if(this.$store.getters.quizAnswers[question.idQuizQuestion]) {
          count++
        }
      })
      return count
    },
  }
}
</script>
